
import { defineComponent, onMounted, computed, ref } from 'vue'
import { store } from '@/store'
import RouteThumbnail from '@/components/routes/RouteThumbnail.vue'
import AppContent from '@/components/layout/AppContent.vue'

export default defineComponent({
  name: 'UserRoutes',
  components: { AppContent, RouteThumbnail },
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      await store.user.fetchUserRoutes()      
      loading.value = false
    })
    
    const user = store.user.get(state => state)
    const routes = computed(() => store.user.getUserRoutes())

    function createRoute() {
      store.modal.showModal('CreateRoute')
    }

    return { user, loading, createRoute, store, routes }
  }
})
